module.exports = __webpack_public_path__ + "img/cover.f9f3a445.jpg";